const ReactBanner = () => {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const [banner, settBanner] = React.useState("");
  const [poster, setPoster] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(true);
  const [showTimer, setShowTimer] = React.useState(false);
  const featuredCollection = ["/collections/mens-bogo"];
  const featuredCollection2 = ['/collections/40-off-selected-styles'];
  const featuredCollections3 = ["/collections/regan-grimes-tlf-athlete-gym-to-street-wear-essentials"];
  const featuredCollections4 = ["/collections/derek-lunsford-tlf-athlete"];
  const outletCollections = ["/collections/mens-outlet", "/collections/mens-outlet-tops", "/collections/mens-outlet-bottoms"];
  const desktopBannerForFeatured = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0304_CollectionBanner_BOGO_Desktop.jpg?v=1709577448";
  const mobileBannerForFeatured = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0304_CollectionBanner_BOGO_Mobile.jpg?v=1709577448";
  const desktopPosterFeatured = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0304_CollectionBanner_BOGO_Desktop.jpg?v=1709577448";
  const mobilePosterFeatured = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0304_CollectionBanner_BOGO_Mobile.jpg?v=1709577448";
  const desktopBannerForFeatured2 = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0304_CollectionBanner_40off_Desktop.jpg?v=1709577448";
  const mobileBannerForFeatured2 = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0304_CollectionBanner_40off_Mobile.jpg?v=1709577449";
  const desktopPosterFeatured2 = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0304_CollectionBanner_40off_Desktop.jpg?v=1709577448";
  const mobilePosterFeatured2 = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0304_CollectionBanner_40off_Mobile.jpg?v=1709577449";
  const desktopBannerForFeatured3 = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0508_CollectionBanner_ReganGrimes_OG-Desktop.jpg?v=1715276243";
  const mobileBannerForFeatured3 = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0509_CollectionBanner_ReganGrimes_Mobile.jpg?v=1715274685";
  const desktopPosterFeatured3 = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0508_CollectionBanner_ReganGrimes_OG-Desktop.jpg?v=1715276243";
  const mobilePosterFeatured3 = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0509_CollectionBanner_ReganGrimes_Mobile.jpg?v=1715274685";
  const desktopBannerForFeatured4 = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0417_CollectionBanner_DerekLunsford_Desktop.jpg?v=1713374584";
  const mobileBannerForFeatured4 = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0417_CollectionBanner_DerekLunsford_Mobile.jpg?v=1713374583";
  const desktopPosterFeatured4 = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0417_CollectionBanner_DerekLunsford_Desktop.jpg?v=1713374584";
  const mobilePosterFeatured4 = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0417_CollectionBanner_DerekLunsford_Mobile.jpg?v=1713374583";
  const defaultDesktopBanner = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0328_CollectionBanner_Perfomance-Launch_Desktop.jpg?v=1711563460";
  const defaultMobileBanner = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0328_CollectionBanner_Perfomance-Launch_Mobile.jpg?v=1711563460";
  const defaultDesktopPoster = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0328_CollectionBanner_Perfomance-Launch_Desktop.jpg?v=1711563460";
  const defaultMobilePoster = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0328_CollectionBanner_Perfomance-Launch_Mobile.jpg?v=1711563460";
  const desktopBannerAfterTimer = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0222_CollectionBanner-TLAF_Desktop.jpg?v=1708612433";
  const mobileBannerAfterTimer = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0222_CollectionBanner-TLAF_Mobile.jpg?v=1708612434";
  const desktopPosterAfterTimer = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0222_CollectionBanner-TLAF_Desktop.jpg?v=1708612433";
  const mobilePosterAfterTimer = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0222_CollectionBanner-TLAF_Mobile.jpg?v=1708612434";
  const currentTime = new Date().toLocaleString("en-US", {
    timeZone: "America/New_York"
  });
  // const currentTime =  new Date("2024-02-16T12:10:00.000-05:00").toLocaleString("en-US", { timeZone: "America/New_York" });
  const timeForCustomBanenrWithTimer = new Date("2024-02-16T11:30:00.000-04:00").toLocaleString("en-US", {
    timeZone: "America/New_York"
  });
  const timeForCustomBanenrNoTimer = new Date("2027-03-23T12:00:00.000-04:00").toLocaleString("en-US", {
    timeZone: "America/New_York"
  });
  const timeForDefaultBanner = new Date("2024-11-24T23:40:00.000-04:00").toLocaleString("en-US", {
    timeZone: "America/New_York"
  });
  const defaultDesktopOutletBanner = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0201_CollectionBanner_OvertockSale_Desktop.jpg?v=1706722645";
  const defaultMobileOutletBanner = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0201_CollectionBanner_OvertockSale_Mobile.jpg?v=1706722644";
  const defaultDesktopOutletPoster = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0201_CollectionBanner_OvertockSale_Desktop.jpg?v=1706722645";
  const defaultMobileOutletPoster = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0201_CollectionBanner_OvertockSale_Mobile.jpg?v=1706722644";
  React.useEffect(() => {
    // featuredCollections.includes(window.location.pathname) && 
    if (outletCollections.includes(window.location.pathname)) {
      windowWidth < 750 ? (settBanner(defaultMobileOutletBanner), setPoster(defaultMobileOutletPoster)) : (settBanner(defaultDesktopOutletBanner), setPoster(defaultDesktopOutletPoster));
      setShowTimer(false);
    }
    // else if (featuredCollection.includes(window.location.pathname)) {
    //     windowWidth < 750 ? (settBanner(mobileBannerForFeatured), setPoster(mobilePosterFeatured)) : (settBanner(desktopBannerForFeatured), setPoster(desktopPosterFeatured))
    // }
    // else if (featuredCollection2.includes(window.location.pathname)) {
    //     windowWidth < 750 ? (settBanner(mobileBannerForFeatured2), setPoster(mobilePosterFeatured2)) : (settBanner(desktopBannerForFeatured2), setPoster(desktopPosterFeatured2))

    // }
    else if (featuredCollections3.includes(window.location.pathname)) {
      windowWidth < 750 ? (settBanner(mobileBannerForFeatured3), setPoster(mobilePosterFeatured3)) : (settBanner(desktopBannerForFeatured3), setPoster(desktopPosterFeatured3));
    } else if (featuredCollections4.includes(window.location.pathname)) {
      windowWidth < 750 ? (settBanner(mobileBannerForFeatured4), setPoster(mobilePosterFeatured4)) : (settBanner(desktopBannerForFeatured4), setPoster(desktopPosterFeatured4));
    } else {
      windowWidth < 750 ? (settBanner(defaultMobileBanner), setPoster(defaultMobilePoster)) : (settBanner(defaultDesktopBanner), setPoster(defaultDesktopPoster));
    }
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return _ => {
      window.removeEventListener('resize', handleResize);
    };
  });

  //     function ChangeUrl() {
  //     window.location.href = "https://tlfapparel.page.link/app";
  // }

  return /*#__PURE__*/React.createElement("div", {
    id: "collectionBanner"
  }, /*#__PURE__*/React.createElement("div", {
    className: `FadeIn collection-loading-placeholder ${windowWidth > 750 ? 'desktop' : 'mobile'}`,
    style: {
      display: isLoading ? 'flex' : 'none'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: poster
  })), windowWidth < 750 ? banner.endsWith('.mp4') ? /*#__PURE__*/React.createElement("video", {
    className: "banner-video-mobile collection-image-mobile",
    autoPlay: true,
    loop: true,
    muted: true,
    playsInline: true,
    style: {
      display: isLoading ? 'none' : 'block'
    },
    onLoadedMetadata: () => setIsLoading(false)
  }, /*#__PURE__*/React.createElement("source", {
    src: banner,
    type: "video/mp4"
  })) : /*#__PURE__*/React.createElement("a", {
    href: "https://tlfapparel.page.link/app"
  }, /*#__PURE__*/React.createElement("img", {
    className: "collection-image-mobile",
    src: banner,
    alt: "TLF Banner",
    style: {
      display: isLoading ? 'none' : 'block'
    },
    onLoad: () => setIsLoading(false)
  })) : banner.endsWith('.mp4') ? /*#__PURE__*/React.createElement("video", {
    className: "banner-video-desktop collection-image-desktop",
    autoPlay: true,
    loop: true,
    muted: true,
    playsInline: true,
    style: {
      display: isLoading ? 'none' : 'block'
    },
    onLoadedMetadata: () => setIsLoading(false)
  }, /*#__PURE__*/React.createElement("source", {
    src: banner,
    type: "video/mp4"
  })) : /*#__PURE__*/React.createElement("img", {
    className: "bannerImg collection-image-desktop",
    alt: "TLF promo banner",
    src: banner,
    style: {
      display: isLoading ? 'none' : 'block'
    },
    onLoad: () => setIsLoading(false)
  }));
};
const ReactWomenBanner = () => {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const [banner, settBanner] = React.useState("");
  const [poster, setPoster] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(true);
  const [showTimer, setShowTimer] = React.useState(false);
  const outletCollections = ["/collections/womens-outlet", "/collections/womens-outlet-tops", "/collections/womens-outlet-bottoms"];
  const featuredCollection = ["/collections/womens-bogo"];
  const featuredCollection2 = ["/collections/women-hyper-power-collection"];
  const desktopBannerForTimer = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0201_CollectionBanner_OvertockSale_Desktop.jpg?v=1706722645";
  const mobileBannerForTimer = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0201_CollectionBanner_OvertockSale_Mobile.jpg?v=1706722644";
  const desktopPosterTimer = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0201_CollectionBanner_OvertockSale_Desktop.jpg?v=1706722645";
  const mobilePosterTimer = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0201_CollectionBanner_OvertockSale_Mobile.jpg?v=1706722644";
  const desktopBannerAfterTimer = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0209_CollectionBanner_Sculpt_Seamless_Sculpt_Seamless_Desktop.jpg?v=1707401672";
  const mobileBannerAfterTimer = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0209_CollectionBanner_Sculpt_Seamless_Sculpt_Seamless_Mobile.jpg?v=1707401672";
  const desktopPosterAfterTimer = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0209_CollectionBanner_Sculpt_Seamless_Sculpt_Seamless_Desktop.jpg?v=1707401672";
  const mobilePosterAfterTimer = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0209_CollectionBanner_Sculpt_Seamless_Sculpt_Seamless_Mobile.jpg?v=1707401672";
  const defaultDesktopBanner = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0425_CollectionBanner_HP-Launch_Desktop.jpg?v=1714052953";
  const defaultMobileBanner = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0425_CollectionBanner_HP-Launch_Mobile.jpg?v=1714052953";
  const desktopBannerPoster = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0425_CollectionBanner_HP-Launch_Desktop.jpg?v=1714052953";
  const mobileBannerPoster = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0425_CollectionBanner_HP-Launch_Mobile.jpg?v=1714052953";
  const currentTime = new Date().toLocaleString("en-US", {
    timeZone: "America/New_York"
  });
  const timeForCustomBanenrWithTimer = new Date("2024-02-10T12:00:00.000-04:00").toLocaleString("en-US", {
    timeZone: "America/New_York"
  });
  const timeForCustomBanenrNoTimer = new Date("2027-04-20T12:00:00.000-04:00").toLocaleString("en-US", {
    timeZone: "America/New_York"
  });
  // const timeForDefaultBanner = new Date("2024-07-06T23:40:00.000-05:00").toLocaleString("en-US", { timeZone: "America/New_York" });

  const desktopBannerForFeatured = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0304_CollectionBanner_BOGO_Desktop.jpg?v=1709577448";
  const mobileBannerForFeatured = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0304_CollectionBanner_BOGO_Mobile.jpg?v=1709577448";
  const desktopPosterFeatured = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0304_CollectionBanner_BOGO_Desktop.jpg?v=1709577448";
  const mobilePosterFeatured = "https://cdn.shopify.com/s/files/1/2665/0346/files/2023-0304_CollectionBanner_BOGO_Mobile.jpg?v=1709577448";
  const desktopBannerForFeatured2 = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0425_CollectionBanner_HP-Launch_Desktop.jpg?v=1714052953";
  const mobileBannerForFeatured2 = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0425_CollectionBanner_HP-Launch_Mobile.jpg?v=1714052953";
  const desktopPosterFeatured2 = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0425_CollectionBanner_HP-Launch_Desktop.jpg?v=1714052953";
  const mobilePosterFeatured2 = "https://cdn.shopify.com/s/files/1/2665/0346/files/2024-0425_CollectionBanner_HP-Launch_Mobile.jpg?v=1714052953";
  React.useEffect(() => {
    if (outletCollections.includes(window.location.pathname) && Date.parse(timeForCustomBanenrNoTimer) - Date.parse(currentTime) > 0) {
      windowWidth < 750 ? (settBanner(mobileBannerForTimer), setPoster(mobilePosterTimer)) : (settBanner(desktopBannerForTimer), setPoster(desktopPosterTimer));
    }

    // else if (window.location.pathname == featuredCollectionURL && Date.parse(timeForDefaultBanner) - Date.parse(currentTime) < 0) {
    //     windowWidth < 750 ? settBanner(mobileBannerAfterTimer) : settBanner(desktopBannerAfterTimer)
    // }

    // else if
    //     (featuredCollection.includes(window.location.pathname) && Date.parse(timeForCustomBanenrNoTimer) - Date.parse(currentTime) > 0) {
    //     windowWidth < 750 ? ((settBanner(mobileBannerForFeatured)), setPoster(mobilePosterFeatured)) : (settBanner(desktopBannerForFeatured), setPoster(desktopPosterFeatured))
    // }
    // else if
    // (featuredCollection2.includes(window.location.pathname) && Date.parse(timeForCustomBanenrNoTimer) - Date.parse(currentTime) > 0) {
    // windowWidth < 750 ? ((settBanner(mobileBannerForFeatured2)), setPoster(mobilePosterFeatured2)) : (settBanner(desktopBannerForFeatured2), setPoster(desktopPosterFeatured2))
    // }
    // else if (appExclusive.includes(window.location.pathname) && Date.parse(timeForCustomBanenrWithTimer) - Date.parse(currentTime) < 0) {
    //     windowWidth < 750 ? ((settBanner(mobileBannerAfterTimer)), setPoster(mobilePosterAfterTimer)) : (settBanner(desktopBannerAfterTimer), setPoster(desktopPosterAfterTimer))
    // }
    else {
      windowWidth < 750 ? (settBanner(defaultMobileBanner), setPoster(mobileBannerPoster)) : (settBanner(defaultDesktopBanner), setPoster(desktopBannerPoster));
    }
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return _ => {
      window.removeEventListener('resize', handleResize);
    };
  });
  function ChangeUrl() {
    window.location.href = "https://tlfapparel.page.link/app";
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "collectionBanner"
  }, /*#__PURE__*/React.createElement("div", {
    className: `FadeIn collection-loading-placeholder ${windowWidth > 750 ? 'desktop' : 'mobile'}`,
    style: {
      display: isLoading ? 'flex' : 'none'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: poster
  })), windowWidth < 750 ? banner.endsWith('.mp4') ? /*#__PURE__*/React.createElement("video", {
    className: "banner-video-mobile collection-image-mobile",
    autoPlay: true,
    loop: true,
    muted: true,
    playsInline: true,
    style: {
      display: isLoading ? 'none' : 'block'
    },
    onLoadedMetadata: () => setIsLoading(false)
  }, /*#__PURE__*/React.createElement("source", {
    src: banner,
    type: "video/mp4"
  })) : /*#__PURE__*/React.createElement("a", {
    href: "https://tlfapparel.page.link/app"
  }, /*#__PURE__*/React.createElement("img", {
    className: "collection-image-mobile",
    src: banner,
    alt: "TLF Banner",
    style: {
      display: isLoading ? 'none' : 'block'
    },
    onLoad: () => setIsLoading(false)
  })) : banner.endsWith('.mp4') ? /*#__PURE__*/React.createElement("video", {
    className: "banner-video-desktop collection-image-desktop",
    autoPlay: true,
    loop: true,
    muted: true,
    playsInline: true,
    style: {
      display: isLoading ? 'none' : 'block'
    },
    onLoadedMetadata: () => setIsLoading(false)
  }, /*#__PURE__*/React.createElement("source", {
    src: banner,
    type: "video/mp4"
  })) : /*#__PURE__*/React.createElement("img", {
    className: "bannerImg collection-image-desktop",
    alt: "TLF promo banner",
    src: banner,
    style: {
      display: isLoading ? 'none' : 'block'
    },
    onLoad: () => setIsLoading(false)
  }), showTimer && /*#__PURE__*/React.createElement("div", {
    id: "reactTimer"
  }, /*#__PURE__*/React.createElement(Timer, {
    time: timeForCustomBanenrNoTimer
  })));
};
if (document.getElementById('reactWomenBanner')) {
  const domContainerForReactWomenBanner = document.getElementById('reactWomenBanner');
  const rootForReactWomenBanner = ReactDOM.createRoot(domContainerForReactWomenBanner);
  rootForReactWomenBanner.render( /*#__PURE__*/React.createElement(ReactWomenBanner, null));
}
if (document.getElementById('reactBanner')) {
  const domContainerForReactBanner = document.getElementById('reactBanner');
  const rootForReactBanner = ReactDOM.createRoot(domContainerForReactBanner);
  rootForReactBanner.render( /*#__PURE__*/React.createElement(ReactBanner, null));
}
